const INITIAL_STATE = {
  list: {}, 
  add: {},
  delete: {},
  errors: {},
  serviceOrderNumberList: {},
  addInvoice: {},
  addManualInvoice:{},
  editInvoice: {},
  deleteInvoice: {},
  addInvoiceLineItem: {},
  invoiceDetail: {},
  editInvoiceLineItem: {},
  deleteInvoiceLineItem: {},
  invoiceSummary: {},
  sendInvoice: {},
  getFinalizeInvoice: {},
  staffList: {},
  refundPayment: {},
  getSalesTax: {},
  suspendAccount: {},
  creditMemo:{},
  creditMemoLineItem:{},
  creditMemoDetail:{},
  InvoiceCreditMemoList:{},
  LastThreeCreditMemo:{},
  invoiceProcess:{},
  invoiceEmailSend:{}
}

const invoice = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_INVOICE_CREDIT_MEMO_LIST':
    return { ...state, ...INITIAL_STATE, InvoiceCreditMemoList: action.data }
  case 'GET_INVOICE_CREDIT_MEMO_LIST_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_INVOICE_LIST':
    return { ...state, ...INITIAL_STATE, list: action.data }
  case 'GET_INVOICE_LIST_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_FINALIZE_INVOICE':
    return { ...state, ...INITIAL_STATE, getFinalizeInvoice: action.data }
  case 'GET_FINALIZE_INVOICE_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_INVOICE_DETAIL':
    return { ...state, ...INITIAL_STATE, invoiceDetail: action.data }
  case 'GET_INVOICE_DETAIL_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'ADD_LOG_PAYMENT_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, add: action.data }
  case 'ADD_LOG_PAYMENT_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'DELETE_LOG_PAYMENT_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, delete: action.data }
  case 'DELETE_LOG_PAYMENT_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'INVOICE_PROCESS_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, invoiceProcess: action.data }
  case 'INVOICE_PROCESS_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'INVOICE_EMAIL_SEND_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, invoiceEmailSend: action.data }
  case 'INVOICE_EMAIL_SEND_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'SERVICE_ORDER_NUMBER_LIST':
    return { ...state, ...INITIAL_STATE, serviceOrderNumberList: action.data }
  case 'SERVICE_ORDER_NUMBER_LIST_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_INVOICE_SUMMARY':
    return { ...state, ...INITIAL_STATE, invoiceSummary: action.data }
  case 'GET_INVOICE_SUMMARY_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'SEND_INVOICE':
    return { ...state, ...INITIAL_STATE, sendInvoice: action.data }
  case 'SEND_INVOICE_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'ADD_INVOICE':
    return { ...state, ...INITIAL_STATE, addInvoice: action.data }
  case 'ADD_INVOICE_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'ADD_MANUAL_INVOICE':
    return { ...state, ...INITIAL_STATE, addManualInvoice: action.data }
  case 'ADD_MANUAL_INVOICE_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'EDIT_INVOICE':
    return { ...state, ...INITIAL_STATE, editInvoice: action.data }
  case 'EDIT_INVOICE_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'DELETE_INVOICE':
    return { ...state, ...INITIAL_STATE, deleteInvoice: action.data }
  case 'DELETE_INVOICE_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'ADD_INVOICE_LINE_ITEM':
    return { ...state, ...INITIAL_STATE, addInvoiceLineItem: action.data }
  case 'ADD_INVOICE_LINE_ITEM_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'EDIT_INVOICE_LINE_ITEM':
    return { ...state, ...INITIAL_STATE, editInvoiceLineItem: action.data }
  case 'EDIT_INVOICE_LINE_ITEM_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'DELETE_INVOICE_LINE_ITEM':
    return { ...state, ...INITIAL_STATE, deleteInvoiceLineItem: action.data }
  case 'DELETE_INVOICE_LINE_ITEM_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_STAFF_LIST_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, staffList: action.data }
  case 'GET_STAFF_LIST_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'REFUND_PAYMENT':
    return { ...state, ...INITIAL_STATE, refundPayment: action.data }
  case 'REFUND_PAYMENT_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_SALES_TAX':
    return { ...state, ...INITIAL_STATE, getSalesTax: action.data }
  case 'GET_SALES_TAX_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'SUSPEND_ACCOUNT':
    return { ...state, ...INITIAL_STATE, suspendAccount: action.data }
  case 'SUSPEND_ACCOUNT_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'ADD_CREDIT_MEMO':
    return { ...state, ...INITIAL_STATE, creditMemo: action.data }
  case 'ADD_CREDIT_MEMO_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'ADD_CREDIT_MEMO_LINE_ITEM':
    return { ...state, ...INITIAL_STATE, creditMemoLineItem: action.data }
  case 'ADD_CREDIT_MEMO_LINE_ITEM_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_CREDIT_MEMO_DETAIL':
    return { ...state, ...INITIAL_STATE, creditMemoDetail: action.data }
  case 'GET_CREDIT_MEMO_DETAIL_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'LAST_THREE_CREDIT_MEMO':
    return { ...state, ...INITIAL_STATE, LastThreeCreditMemo: action.data }
  case 'LAST_THREE_CREDIT_MEMO_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default invoice;
